import React from 'react'
import Header from '../../Components/Header';
import CompanyIntro from "./CompanyIntro";
import FeedbackSection from "./FeedbackSection";
// no hooks needed here


function FeedbackFormData({ feedbackData, cmsData }) {
  const data = feedbackData ?? cmsData ?? null;
  if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production') {
    console.log("Feedback Data in FeedbackFormData:", data);
  }
  return (
    <main className="relative w-full min-h-screen overflow-x-hidden">
      <Header />
      <div className="-mt-5">
        <CompanyIntro />
      </div>
      <FeedbackSection cmsData={data} />
      
     
    </main>
  );
}

export default FeedbackFormData;